export const filterLinkToProductReviews = (v: string) => {
  return v + '#reviews'
}
